/* AUTO-GENERATED by INYRON World Forge. */
export const WORLD_FORGE_COMPOSITIONS={
  "aurelios": {
    "id": "aurelios",
    "directive": {
      "mood": "solar ruin grandeur; heat, age, expedition traces, violent golden atmosphere",
      "skyline": [
        "broken monumental ruin silhouettes",
        "offset solar monoliths",
        "distant eroded rock masses"
      ],
      "foreground": [
        "asymmetric broken stone framing",
        "expedition debris at lateral corners"
      ],
      "destruction": "stone/wood destruction should frame impact arcs, never cover fighter silhouettes",
      "palette": [
        "#351910",
        "#ffbc64",
        "#8b4b2d",
        "#e4a75f"
      ]
    },
    "sky": {
      "zenithColor": null,
      "celestial": {
        "position": [
          -14,
          14,
          -30
        ],
        "radius": 4.6,
        "intensity": 1.25
      },
      "hazePlanes": [
        {
          "position": [
            -18,
            6,
            -28
          ],
          "scale": [
            13,
            7,
            1
          ],
          "opacity": 0.055
        },
        {
          "position": [
            16,
            8,
            -35
          ],
          "scale": [
            17,
            9,
            1
          ],
          "opacity": 0.04
        },
        {
          "position": [
            0,
            4,
            -23
          ],
          "scale": [
            22,
            5,
            1
          ],
          "opacity": 0.035
        }
      ]
    },
    "layers": {
      "horizon": [
        {
          "id": "aurelios-horizon-0",
          "layer": "horizon",
          "asset": "boulder",
          "position": [
            -11.661,
            0,
            -33.635
          ],
          "rotationY": 0.182,
          "scale": 2.255,
          "height": 5.418,
          "destructible": false,
          "accent": null
        },
        {
          "id": "aurelios-horizon-1",
          "layer": "horizon",
          "asset": "statue",
          "position": [
            11.776,
            0,
            -31.489
          ],
          "rotationY": -0.989,
          "scale": 2.732,
          "height": 11.855,
          "destructible": false,
          "accent": null
        },
        {
          "id": "aurelios-horizon-2",
          "layer": "horizon",
          "asset": "boulder",
          "position": [
            -17.027,
            0,
            -29.034
          ],
          "rotationY": 1.133,
          "scale": 2.734,
          "height": 6.568,
          "destructible": false,
          "accent": null
        },
        {
          "id": "aurelios-horizon-3",
          "layer": "horizon",
          "asset": "statue",
          "position": [
            16.175,
            0,
            -29.839
          ],
          "rotationY": -0.563,
          "scale": 2.085,
          "height": 9.05,
          "destructible": false,
          "accent": null
        }
      ],
      "far": [
        {
          "id": "aurelios-far-0",
          "layer": "far",
          "asset": "boulder",
          "position": [
            -9.683,
            0,
            -22.783
          ],
          "rotationY": 0.696,
          "scale": 1.416,
          "height": 2.195,
          "destructible": false,
          "accent": null
        },
        {
          "id": "aurelios-far-1",
          "layer": "far",
          "asset": "boulder",
          "position": [
            9.731,
            0,
            -18.471
          ],
          "rotationY": -0.441,
          "scale": 1.315,
          "height": 2.038,
          "destructible": false,
          "accent": null
        },
        {
          "id": "aurelios-far-2",
          "layer": "far",
          "asset": "statue",
          "position": [
            -11.57,
            0,
            -20.869
          ],
          "rotationY": 1.151,
          "scale": 1.323,
          "height": 3.705,
          "destructible": false,
          "accent": null
        },
        {
          "id": "aurelios-far-3",
          "layer": "far",
          "asset": "statue",
          "position": [
            12.352,
            0,
            -21.27
          ],
          "rotationY": -0.438,
          "scale": 1.483,
          "height": 4.153,
          "destructible": false,
          "accent": null
        },
        {
          "id": "aurelios-far-4",
          "layer": "far",
          "asset": "moonRock",
          "position": [
            -14.785,
            0,
            -23.003
          ],
          "rotationY": 0.194,
          "scale": 1.42,
          "height": 1.775,
          "destructible": false,
          "accent": null
        },
        {
          "id": "aurelios-far-5",
          "layer": "far",
          "asset": "moonRock",
          "position": [
            14.862,
            0,
            -19.521
          ],
          "rotationY": -0.879,
          "scale": 1.38,
          "height": 1.725,
          "destructible": false,
          "accent": null
        }
      ],
      "mid": [
        {
          "id": "aurelios-mid-0",
          "layer": "mid",
          "asset": "statue",
          "position": [
            -8.657,
            0,
            -14.21
          ],
          "rotationY": 0.612,
          "scale": 1.341,
          "height": 3.754,
          "destructible": true,
          "accent": null
        },
        {
          "id": "aurelios-mid-1",
          "layer": "mid",
          "asset": "boulder",
          "position": [
            8.747,
            0,
            -13.421
          ],
          "rotationY": -1.023,
          "scale": 1.335,
          "height": 2.069,
          "destructible": true,
          "accent": null
        },
        {
          "id": "aurelios-mid-2",
          "layer": "mid",
          "asset": "woodCrate",
          "position": [
            -10.54,
            0,
            -15.022
          ],
          "rotationY": 1.139,
          "scale": 1.07,
          "height": 1.124,
          "destructible": true,
          "accent": null
        },
        {
          "id": "aurelios-mid-3",
          "layer": "mid",
          "asset": "woodCrate",
          "position": [
            10.506,
            0,
            -15.337
          ],
          "rotationY": -0.707,
          "scale": 1.04,
          "height": 1.092,
          "destructible": true,
          "accent": null
        },
        {
          "id": "aurelios-mid-4",
          "layer": "mid",
          "asset": "moonRock",
          "position": [
            -12.513,
            0,
            -13.346
          ],
          "rotationY": 1.012,
          "scale": 1.18,
          "height": 1.475,
          "destructible": true,
          "accent": null
        },
        {
          "id": "aurelios-mid-5",
          "layer": "mid",
          "asset": "jerrycan",
          "position": [
            12.498,
            0,
            -11.365
          ],
          "rotationY": -1.005,
          "scale": 1.594,
          "height": 1.148,
          "destructible": true,
          "accent": null
        }
      ],
      "near": [
        {
          "id": "aurelios-near-0",
          "layer": "near",
          "asset": "boulder",
          "position": [
            -8.729,
            0,
            -8.86
          ],
          "rotationY": 0.403,
          "scale": 1.346,
          "height": 2.086,
          "destructible": true,
          "accent": null
        },
        {
          "id": "aurelios-near-1",
          "layer": "near",
          "asset": "woodCrate",
          "position": [
            9.036,
            0,
            -8.909
          ],
          "rotationY": -0.753,
          "scale": 1.083,
          "height": 1.137,
          "destructible": true,
          "accent": null
        },
        {
          "id": "aurelios-near-2",
          "layer": "near",
          "asset": "jerrycan",
          "position": [
            -11.03,
            0,
            -9.396
          ],
          "rotationY": 0.911,
          "scale": 1.165,
          "height": 0.839,
          "destructible": true,
          "accent": null
        },
        {
          "id": "aurelios-near-3",
          "layer": "near",
          "asset": "moonRock",
          "position": [
            10.801,
            0,
            -9.542
          ],
          "rotationY": -0.485,
          "scale": 1.005,
          "height": 1.257,
          "destructible": true,
          "accent": null
        }
      ],
      "foreground": [
        {
          "id": "aurelios-foreground-0",
          "layer": "foreground",
          "asset": "boulder",
          "position": [
            -11.18,
            0,
            5.17
          ],
          "rotationY": 0.324,
          "scale": 1.726,
          "height": 2.676,
          "destructible": false,
          "accent": null
        },
        {
          "id": "aurelios-foreground-1",
          "layer": "foreground",
          "asset": "boulder",
          "position": [
            11.502,
            0,
            2.279
          ],
          "rotationY": -0.386,
          "scale": 1.822,
          "height": 2.824,
          "destructible": false,
          "accent": null
        },
        {
          "id": "aurelios-foreground-2",
          "layer": "foreground",
          "asset": "woodCrate",
          "position": [
            -14.334,
            0,
            5.138
          ],
          "rotationY": 0.591,
          "scale": 1.235,
          "height": 1.296,
          "destructible": false,
          "accent": null
        },
        {
          "id": "aurelios-foreground-3",
          "layer": "foreground",
          "asset": "woodCrate",
          "position": [
            14.428,
            0,
            3.845
          ],
          "rotationY": -1.04,
          "scale": 1.749,
          "height": 1.836,
          "destructible": false,
          "accent": null
        }
      ]
    },
    "destruction": [
      {
        "stageId": "aurelios-pillar-left",
        "priority": "hero",
        "cameraReadability": 1,
        "fxBias": "radial"
      },
      {
        "stageId": "aurelios-pillar-right",
        "priority": "hero",
        "cameraReadability": 1,
        "fxBias": "lateral"
      },
      {
        "stageId": "aurelios-gate",
        "priority": "hero",
        "cameraReadability": 1,
        "fxBias": "radial"
      },
      {
        "stageId": "ruin-statue-l",
        "priority": "secondary",
        "cameraReadability": 0.75,
        "fxBias": "lateral"
      },
      {
        "stageId": "ruin-statue-r",
        "priority": "secondary",
        "cameraReadability": 0.75,
        "fxBias": "radial"
      },
      {
        "stageId": "wood-crate-l",
        "priority": "secondary",
        "cameraReadability": 0.75,
        "fxBias": "lateral"
      },
      {
        "stageId": "wood-crate-r",
        "priority": "secondary",
        "cameraReadability": 0.75,
        "fxBias": "radial"
      },
      {
        "stageId": "sun-boulder-l",
        "priority": "ambient",
        "cameraReadability": 0.75,
        "fxBias": "lateral"
      },
      {
        "stageId": "sun-boulder-r",
        "priority": "ambient",
        "cameraReadability": 0.75,
        "fxBias": "radial"
      }
    ]
  },
  "xyloria": {
    "id": "xyloria",
    "directive": {
      "mood": "bioluminescent crystal sanctuary; layered luminous depth and alien sacred geometry",
      "skyline": [
        "tall crystal silhouettes",
        "temple spines",
        "floating luminous motes"
      ],
      "foreground": [
        "crystal flora framing",
        "moon-rock bases with violet/teal accents"
      ],
      "destruction": "crystal fracture and organic collapse should read as luminous secondary explosions",
      "palette": [
        "#08262b",
        "#62ffb1",
        "#9475ff",
        "#73f7ff"
      ]
    },
    "sky": {
      "zenithColor": null,
      "celestial": {
        "position": [
          12,
          14,
          -30
        ],
        "radius": 4.6,
        "intensity": 1.6
      },
      "hazePlanes": [
        {
          "position": [
            -18,
            6,
            -28
          ],
          "scale": [
            13,
            7,
            1
          ],
          "opacity": 0.055
        },
        {
          "position": [
            16,
            8,
            -35
          ],
          "scale": [
            17,
            9,
            1
          ],
          "opacity": 0.04
        },
        {
          "position": [
            0,
            4,
            -23
          ],
          "scale": [
            22,
            5,
            1
          ],
          "opacity": 0.035
        }
      ]
    },
    "layers": {
      "horizon": [
        {
          "id": "xyloria-horizon-0",
          "layer": "horizon",
          "asset": "crystalPlant",
          "position": [
            -11.315,
            0,
            -31.865
          ],
          "rotationY": 0.392,
          "scale": 2.024,
          "height": 4.549,
          "destructible": false,
          "accent": null
        },
        {
          "id": "xyloria-horizon-1",
          "layer": "horizon",
          "asset": "statue",
          "position": [
            11.035,
            0,
            -33.044
          ],
          "rotationY": -0.826,
          "scale": 1.869,
          "height": 8.111,
          "destructible": false,
          "accent": null
        },
        {
          "id": "xyloria-horizon-2",
          "layer": "horizon",
          "asset": "crystalPlant",
          "position": [
            -15.879,
            0,
            -29.081
          ],
          "rotationY": 0.897,
          "scale": 1.907,
          "height": 4.286,
          "destructible": false,
          "accent": null
        },
        {
          "id": "xyloria-horizon-3",
          "layer": "horizon",
          "asset": "statue",
          "position": [
            16.986,
            0,
            -32.159
          ],
          "rotationY": -0.811,
          "scale": 1.724,
          "height": 7.484,
          "destructible": false,
          "accent": null
        }
      ],
      "far": [
        {
          "id": "xyloria-far-0",
          "layer": "far",
          "asset": "crystalPlant",
          "position": [
            -9.3,
            0,
            -21.108
          ],
          "rotationY": 0.624,
          "scale": 1.395,
          "height": 2.023,
          "destructible": false,
          "accent": null
        },
        {
          "id": "xyloria-far-1",
          "layer": "far",
          "asset": "crystalPlant",
          "position": [
            9.735,
            0,
            -18.58
          ],
          "rotationY": -0.239,
          "scale": 1.29,
          "height": 1.871,
          "destructible": false,
          "accent": null
        },
        {
          "id": "xyloria-far-2",
          "layer": "far",
          "asset": "moonRock",
          "position": [
            -11.521,
            0,
            -19.907
          ],
          "rotationY": 1.107,
          "scale": 1.716,
          "height": 2.145,
          "destructible": false,
          "accent": null
        },
        {
          "id": "xyloria-far-3",
          "layer": "far",
          "asset": "moonRock",
          "position": [
            11.581,
            0,
            -22.686
          ],
          "rotationY": -0.978,
          "scale": 1.837,
          "height": 2.297,
          "destructible": false,
          "accent": null
        },
        {
          "id": "xyloria-far-4",
          "layer": "far",
          "asset": "statue",
          "position": [
            -14.6,
            0,
            -19.327
          ],
          "rotationY": 0.623,
          "scale": 1.251,
          "height": 3.504,
          "destructible": false,
          "accent": null
        },
        {
          "id": "xyloria-far-5",
          "layer": "far",
          "asset": "statue",
          "position": [
            14.618,
            0,
            -23.104
          ],
          "rotationY": -0.753,
          "scale": 1.962,
          "height": 5.493,
          "destructible": false,
          "accent": null
        }
      ],
      "mid": [
        {
          "id": "xyloria-mid-0",
          "layer": "mid",
          "asset": "crystalPlant",
          "position": [
            -8.763,
            0,
            -13.967
          ],
          "rotationY": 0.18,
          "scale": 1.632,
          "height": 2.366,
          "destructible": true,
          "accent": null
        },
        {
          "id": "xyloria-mid-1",
          "layer": "mid",
          "asset": "moonRock",
          "position": [
            9.102,
            0,
            -15.797
          ],
          "rotationY": -0.219,
          "scale": 1.241,
          "height": 1.552,
          "destructible": true,
          "accent": null
        },
        {
          "id": "xyloria-mid-2",
          "layer": "mid",
          "asset": "crystalPlant",
          "position": [
            -10.437,
            0,
            -16.638
          ],
          "rotationY": 0.651,
          "scale": 1.476,
          "height": 2.14,
          "destructible": true,
          "accent": null
        },
        {
          "id": "xyloria-mid-3",
          "layer": "mid",
          "asset": "moonRock",
          "position": [
            10.675,
            0,
            -14.021
          ],
          "rotationY": -0.125,
          "scale": 1.016,
          "height": 1.27,
          "destructible": true,
          "accent": null
        },
        {
          "id": "xyloria-mid-4",
          "layer": "mid",
          "asset": "statue",
          "position": [
            -12.384,
            0,
            -12.372
          ],
          "rotationY": 0.492,
          "scale": 1.487,
          "height": 4.163,
          "destructible": true,
          "accent": null
        },
        {
          "id": "xyloria-mid-5",
          "layer": "mid",
          "asset": "crystalPlant",
          "position": [
            12.196,
            0,
            -12.592
          ],
          "rotationY": -1.168,
          "scale": 1.239,
          "height": 1.796,
          "destructible": true,
          "accent": null
        }
      ],
      "near": [
        {
          "id": "xyloria-near-0",
          "layer": "near",
          "asset": "crystalPlant",
          "position": [
            -8.951,
            0,
            -8.794
          ],
          "rotationY": 0.356,
          "scale": 0.925,
          "height": 1.341,
          "destructible": true,
          "accent": null
        },
        {
          "id": "xyloria-near-1",
          "layer": "near",
          "asset": "moonRock",
          "position": [
            8.946,
            0,
            -9.924
          ],
          "rotationY": -0.239,
          "scale": 0.937,
          "height": 1.171,
          "destructible": true,
          "accent": null
        },
        {
          "id": "xyloria-near-2",
          "layer": "near",
          "asset": "crystalPlant",
          "position": [
            -10.823,
            0,
            -8.808
          ],
          "rotationY": 0.948,
          "scale": 1.082,
          "height": 1.569,
          "destructible": true,
          "accent": null
        },
        {
          "id": "xyloria-near-3",
          "layer": "near",
          "asset": "moonRock",
          "position": [
            10.837,
            0,
            -8.971
          ],
          "rotationY": -0.908,
          "scale": 1.045,
          "height": 1.306,
          "destructible": true,
          "accent": null
        }
      ],
      "foreground": [
        {
          "id": "xyloria-foreground-0",
          "layer": "foreground",
          "asset": "moonRock",
          "position": [
            -11.474,
            0,
            3.022
          ],
          "rotationY": 0.157,
          "scale": 1.375,
          "height": 1.718,
          "destructible": false,
          "accent": null
        },
        {
          "id": "xyloria-foreground-1",
          "layer": "foreground",
          "asset": "crystalPlant",
          "position": [
            11.476,
            0,
            2.981
          ],
          "rotationY": -0.307,
          "scale": 1.178,
          "height": 1.708,
          "destructible": false,
          "accent": null
        },
        {
          "id": "xyloria-foreground-2",
          "layer": "foreground",
          "asset": "moonRock",
          "position": [
            -14.561,
            0,
            2.293
          ],
          "rotationY": 1.058,
          "scale": 1.686,
          "height": 2.108,
          "destructible": false,
          "accent": null
        },
        {
          "id": "xyloria-foreground-3",
          "layer": "foreground",
          "asset": "crystalPlant",
          "position": [
            14.363,
            0,
            5.228
          ],
          "rotationY": -1.018,
          "scale": 1.866,
          "height": 2.705,
          "destructible": false,
          "accent": null
        }
      ]
    },
    "destruction": [
      {
        "stageId": "xyloria-crystal-left",
        "priority": "hero",
        "cameraReadability": 1,
        "fxBias": "radial"
      },
      {
        "stageId": "xyloria-crystal-right",
        "priority": "hero",
        "cameraReadability": 1,
        "fxBias": "lateral"
      },
      {
        "stageId": "xyloria-root-core",
        "priority": "hero",
        "cameraReadability": 1,
        "fxBias": "radial"
      },
      {
        "stageId": "prism-statue-l",
        "priority": "secondary",
        "cameraReadability": 0.75,
        "fxBias": "lateral"
      },
      {
        "stageId": "prism-statue-r",
        "priority": "secondary",
        "cameraReadability": 0.75,
        "fxBias": "radial"
      },
      {
        "stageId": "moon-rock-l",
        "priority": "secondary",
        "cameraReadability": 0.75,
        "fxBias": "lateral"
      },
      {
        "stageId": "moon-rock-r",
        "priority": "secondary",
        "cameraReadability": 0.75,
        "fxBias": "radial"
      },
      {
        "stageId": "crystal-flora-l",
        "priority": "ambient",
        "cameraReadability": 0.75,
        "fxBias": "lateral"
      },
      {
        "stageId": "crystal-flora-r",
        "priority": "ambient",
        "cameraReadability": 0.75,
        "fxBias": "radial"
      }
    ]
  },
  "capital": {
    "id": "capital",
    "directive": {
      "mood": "high-tech capital ruin; severe industrial massing, blue reactor light, civic monumentality",
      "skyline": [
        "obelisk silhouette",
        "industrial wall masses",
        "reactor/service towers"
      ],
      "foreground": [
        "barriers and service equipment as side framing",
        "low military supply clutter at corners"
      ],
      "destruction": "metal/stone collapse should expose blue reactor light and preserve fight readability",
      "palette": [
        "#0a1425",
        "#5bbcff",
        "#26394d",
        "#9bdcff"
      ]
    },
    "sky": {
      "zenithColor": null,
      "celestial": {
        "position": [
          -9,
          14,
          -30
        ],
        "radius": 3.2,
        "intensity": 1.25
      },
      "hazePlanes": [
        {
          "position": [
            -18,
            6,
            -28
          ],
          "scale": [
            13,
            7,
            1
          ],
          "opacity": 0.055
        },
        {
          "position": [
            16,
            8,
            -35
          ],
          "scale": [
            17,
            9,
            1
          ],
          "opacity": 0.04
        },
        {
          "position": [
            0,
            4,
            -23
          ],
          "scale": [
            22,
            5,
            1
          ],
          "opacity": 0.035
        }
      ]
    },
    "layers": {
      "horizon": [
        {
          "id": "capital-horizon-0",
          "layer": "horizon",
          "asset": "barrier",
          "position": [
            -11.699,
            0,
            -28.499
          ],
          "rotationY": 0.852,
          "scale": 2.3,
          "height": 4.1,
          "destructible": false,
          "accent": null
        },
        {
          "id": "capital-horizon-1",
          "layer": "horizon",
          "asset": "statue",
          "position": [
            12.339,
            0,
            -33.23
          ],
          "rotationY": -1.06,
          "scale": 2.218,
          "height": 9.625,
          "destructible": false,
          "accent": null
        },
        {
          "id": "capital-horizon-2",
          "layer": "horizon",
          "asset": "barrier",
          "position": [
            -16.986,
            0,
            -32.766
          ],
          "rotationY": 0.525,
          "scale": 2.613,
          "height": 4.657,
          "destructible": false,
          "accent": null
        },
        {
          "id": "capital-horizon-3",
          "layer": "horizon",
          "asset": "statue",
          "position": [
            15.906,
            0,
            -27.733
          ],
          "rotationY": -1.095,
          "scale": 1.872,
          "height": 8.125,
          "destructible": false,
          "accent": null
        }
      ],
      "far": [
        {
          "id": "capital-far-0",
          "layer": "far",
          "asset": "barrier",
          "position": [
            -9.85,
            0,
            -24.682
          ],
          "rotationY": 0.868,
          "scale": 1.604,
          "height": 1.844,
          "destructible": false,
          "accent": null
        },
        {
          "id": "capital-far-1",
          "layer": "far",
          "asset": "barrier",
          "position": [
            9.833,
            0,
            -21.071
          ],
          "rotationY": -0.463,
          "scale": 1.823,
          "height": 2.097,
          "destructible": false,
          "accent": null
        },
        {
          "id": "capital-far-2",
          "layer": "far",
          "asset": "militaryCrate",
          "position": [
            -11.833,
            0,
            -23.029
          ],
          "rotationY": 0.95,
          "scale": 1.697,
          "height": 1.697,
          "destructible": false,
          "accent": null
        },
        {
          "id": "capital-far-3",
          "layer": "far",
          "asset": "barrel",
          "position": [
            11.579,
            0,
            -22.017
          ],
          "rotationY": -0.692,
          "scale": 1.689,
          "height": 2.026,
          "destructible": false,
          "accent": null
        },
        {
          "id": "capital-far-4",
          "layer": "far",
          "asset": "barrel",
          "position": [
            -14.964,
            0,
            -22.787
          ],
          "rotationY": 0.674,
          "scale": 1.878,
          "height": 2.254,
          "destructible": false,
          "accent": null
        },
        {
          "id": "capital-far-5",
          "layer": "far",
          "asset": "statue",
          "position": [
            14.797,
            0,
            -24.286
          ],
          "rotationY": -0.903,
          "scale": 2.016,
          "height": 5.646,
          "destructible": false,
          "accent": null
        }
      ],
      "mid": [
        {
          "id": "capital-mid-0",
          "layer": "mid",
          "asset": "barrier",
          "position": [
            -9.092,
            0,
            -13.899
          ],
          "rotationY": 1.135,
          "scale": 1.145,
          "height": 1.317,
          "destructible": true,
          "accent": null
        },
        {
          "id": "capital-mid-1",
          "layer": "mid",
          "asset": "militaryCrate",
          "position": [
            8.878,
            0,
            -11.484
          ],
          "rotationY": -0.569,
          "scale": 1.236,
          "height": 1.236,
          "destructible": true,
          "accent": null
        },
        {
          "id": "capital-mid-2",
          "layer": "mid",
          "asset": "barrel",
          "position": [
            -10.613,
            0,
            -16.145
          ],
          "rotationY": 0.855,
          "scale": 1.589,
          "height": 1.907,
          "destructible": true,
          "accent": null
        },
        {
          "id": "capital-mid-3",
          "layer": "mid",
          "asset": "militaryCrate",
          "position": [
            10.537,
            0,
            -11.518
          ],
          "rotationY": -0.235,
          "scale": 1.122,
          "height": 1.122,
          "destructible": true,
          "accent": null
        },
        {
          "id": "capital-mid-4",
          "layer": "mid",
          "asset": "toolbox",
          "position": [
            -12.455,
            0,
            -11.834
          ],
          "rotationY": 0.47,
          "scale": 1.341,
          "height": 0.778,
          "destructible": true,
          "accent": null
        },
        {
          "id": "capital-mid-5",
          "layer": "mid",
          "asset": "jerrycan",
          "position": [
            12.784,
            0,
            -14.759
          ],
          "rotationY": -0.211,
          "scale": 1.644,
          "height": 1.184,
          "destructible": true,
          "accent": null
        }
      ],
      "near": [
        {
          "id": "capital-near-0",
          "layer": "near",
          "asset": "barrier",
          "position": [
            -8.919,
            0,
            -8.177
          ],
          "rotationY": 0.145,
          "scale": 1.109,
          "height": 1.275,
          "destructible": true,
          "accent": null
        },
        {
          "id": "capital-near-1",
          "layer": "near",
          "asset": "militaryCrate",
          "position": [
            9.067,
            0,
            -7.904
          ],
          "rotationY": -0.379,
          "scale": 1.314,
          "height": 1.314,
          "destructible": true,
          "accent": null
        },
        {
          "id": "capital-near-2",
          "layer": "near",
          "asset": "barrel",
          "position": [
            -10.984,
            0,
            -9.267
          ],
          "rotationY": 0.197,
          "scale": 0.975,
          "height": 1.17,
          "destructible": true,
          "accent": null
        },
        {
          "id": "capital-near-3",
          "layer": "near",
          "asset": "toolbox",
          "position": [
            10.559,
            0,
            -9.245
          ],
          "rotationY": -1.107,
          "scale": 1.112,
          "height": 0.645,
          "destructible": true,
          "accent": null
        }
      ],
      "foreground": [
        {
          "id": "capital-foreground-0",
          "layer": "foreground",
          "asset": "barrier",
          "position": [
            -11.549,
            0,
            5.052
          ],
          "rotationY": 1.167,
          "scale": 1.621,
          "height": 1.865,
          "destructible": false,
          "accent": null
        },
        {
          "id": "capital-foreground-1",
          "layer": "foreground",
          "asset": "barrier",
          "position": [
            11.35,
            0,
            5.539
          ],
          "rotationY": -0.702,
          "scale": 1.899,
          "height": 2.184,
          "destructible": false,
          "accent": null
        },
        {
          "id": "capital-foreground-2",
          "layer": "foreground",
          "asset": "militaryCrate",
          "position": [
            -14.391,
            0,
            4.081
          ],
          "rotationY": 1.051,
          "scale": 1.55,
          "height": 1.55,
          "destructible": false,
          "accent": null
        },
        {
          "id": "capital-foreground-3",
          "layer": "foreground",
          "asset": "militaryCrate",
          "position": [
            14.648,
            0,
            2.784
          ],
          "rotationY": -1.012,
          "scale": 1.322,
          "height": 1.322,
          "destructible": false,
          "accent": null
        }
      ]
    },
    "destruction": [
      {
        "stageId": "capital-obelisk-core",
        "priority": "hero",
        "cameraReadability": 1,
        "fxBias": "radial"
      },
      {
        "stageId": "capital-support-left",
        "priority": "hero",
        "cameraReadability": 1,
        "fxBias": "lateral"
      },
      {
        "stageId": "capital-support-right",
        "priority": "hero",
        "cameraReadability": 1,
        "fxBias": "radial"
      },
      {
        "stageId": "barrier-l",
        "priority": "secondary",
        "cameraReadability": 0.75,
        "fxBias": "lateral"
      },
      {
        "stageId": "barrier-r",
        "priority": "secondary",
        "cameraReadability": 0.75,
        "fxBias": "radial"
      },
      {
        "stageId": "capital-crate-l",
        "priority": "secondary",
        "cameraReadability": 0.75,
        "fxBias": "lateral"
      },
      {
        "stageId": "capital-crate-r",
        "priority": "secondary",
        "cameraReadability": 0.75,
        "fxBias": "radial"
      },
      {
        "stageId": "reactor-barrel-l",
        "priority": "ambient",
        "cameraReadability": 0.75,
        "fxBias": "lateral"
      },
      {
        "stageId": "reactor-barrel-r",
        "priority": "ambient",
        "cameraReadability": 0.75,
        "fxBias": "radial"
      },
      {
        "stageId": "service-can",
        "priority": "ambient",
        "cameraReadability": 0.75,
        "fxBias": "lateral"
      },
      {
        "stageId": "field-toolbox",
        "priority": "ambient",
        "cameraReadability": 0.75,
        "fxBias": "radial"
      }
    ]
  }
} as const
export function worldForgeCompositionForArena(id:string){return WORLD_FORGE_COMPOSITIONS[id as keyof typeof WORLD_FORGE_COMPOSITIONS]??WORLD_FORGE_COMPOSITIONS.aurelios}
